<template>
  <div>
    <div class="page-title">Application List</div>
    <div class="page-box">
      <div class="page-box-title">
        <el-dropdown
          v-show="multipleSelection.length !== 0"
          split-button
          @command="handleCommand"
        >
          {{ multipleSelection.length }} User selected
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="d">Batch Delete All</el-dropdown-item>
            <el-dropdown-item command="c">Batch Delete</el-dropdown-item>
            <el-dropdown-item command="a">Batch Edit Status</el-dropdown-item>
            <el-dropdown-item command="b"
              >Batch Send Announcement & Email
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-show="multipleSelection.length == 0"
          type="primary"
          @click="show3 = !show3"
          >Filter</el-button
        >
        <el-row type="flex" :gutter="20">
          <el-col :span="9">     
            <el-dropdown split-button  @command="handleCommandFolder" type="warning">
              <i class="el-icon-download"></i> Folder
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">Download Selected Applicant Folder</el-dropdown-item>
                <el-dropdown-item command="b">Batch Folder Download</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <el-col :span="8"> 
            <!-- <el-button icon="el-icon-upload2" type="warning">Import</el-button> -->
            <importExcel fileName="applicationFile" @importExcel="importExcel"></importExcel>
          </el-col>
          <el-col :span="8"> <el-button icon="el-icon-download" @click="onExport" type="warning"
            >Export</el-button
          ></el-col>
          <el-col :span="8"> <el-button icon="el-icon-download" @click="onExportAll" type="warning"
            >ExportAll</el-button
          ></el-col>
        </el-row>
      </div>
      <div class="search-box">
        <el-collapse-transition>
          <el-form
            label-width="180px"
            v-show="show3"
            ref="ruleForm"
            :model="formLabelAlign"
          >
            <el-form-item label="Applicant">
              <el-input v-model="formLabelAlign.likeApplicant"></el-input>
            </el-form-item>
            <el-form-item label="Stage">
              <el-select v-model="formLabelAlign.stage" placeholder="">
                <el-option
                  v-for="(item, index) in applicationStage"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Status">
              <el-select v-model="formLabelAlign.status" placeholder="">
                <el-option
                  v-for="(item, index) in applicationStatus"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="warning" @click="onSearch"
                >Search</el-button
              >
              <el-button icon="el-icon-refresh-left" @click="onReset"
                >Reset</el-button
              >
            </el-form-item>
          </el-form>
        </el-collapse-transition>
      </div>
      <el-table
        :data="application"
        @sort-change="handleSortChange"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%;"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="registrationNo" sortable="custom" label="Registration">
        </el-table-column>
        <el-table-column label="Applicant" prop="applicantName" sortable="custom">
          <template slot-scope="{ row }">
            <!-- <span v-if="row.applicantName" 
              >{{ JSON.parse(row.applicantName).en || "" }}
              {{ JSON.parse(row.applicantName).zh_tc || "" }}</span
            > -->
            <span v-html="jsonParseApplicantName(row).replace(/ /g, '&nbsp;')"></span>
          </template>
        </el-table-column>
        <el-table-column prop="applicationDate" sortable="custom" label="Application Date">
          <template slot-scope="{ row }">
            <span>{{ row.applicationDate | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="paidAt" sortable="custom" label="Payment Date">
          <template slot-scope="{ row }">
            <span v-if="row.paidAt">{{ row.paidAt.date | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="stage" label="Stage" sortable="custom">
          <template slot-scope="{ row }">
            <span>{{ row.stage | applicationStage }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="Action">
          <template slot-scope="{ row }">
            <span
              class="action-link cursor"
              @click="onView(row.id, row.formType)"
              >View</span
            >&nbsp;
            <span
              class="action-link cursor"
              @click="onEdit(row.id, row.formType)"
              >Edit</span
            >&nbsp;
            <span class="action-link cursor" @click="onExportPDF(row.id)"
              >Export PDF</span
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        layout="total, sizes, prev, pager, next"
        :page.sync="formLabelAlign._page"
        :limit.sync="formLabelAlign._limit"
        @pagination="getApplicationPagination"
      />
      <loadingSlotDialog
        @close="close"
        :centerDialogVisible="centerDialogVisible"
      >
        <batchSendAnnouncement
          @closeCenter="closeCenter"
          :formType="formType"
          :applicationFormIds="applicationFormIds"
        ></batchSendAnnouncement>
      </loadingSlotDialog>
      <loadingSlotDialog
        @close="closeDelete"
        :centerDialogVisible="centerDeleteDialogVisible"
      >
        <img src="@/assets/images/feather-alert-circle.png" />
        <div class="dialog-text">Are you sure to delete this item ?</div>
        <el-button @click="onConfirm" type="danger">Confirm</el-button>
        <el-button @click="onCancel">Cancel</el-button>
      </loadingSlotDialog>
      <loadingDialog :centerDialogVisible="centerDialogVisibleLoading"></loadingDialog>
    </div>
  </div>
</template>

<script>
import loadingDialog from "@/components/loadingDialog";
import importExcel from "@/components/importExcel/index.vue";
import { downloadFile,getFileName } from "@/utils/is-rules";
import Pagination from "@/components/Pagination";
import {
  getApplication,
  addBatchChangeApplicationFormsStage,
  batchExportApplicationsRequest,
  batchDeleteApplicationForms,
  exportRequest,
  exportAttachments,
} from "@/api/admin/application";
import loadingSlotDialog from "@/components/loadingSlotDialog";
import batchSendAnnouncement from "@/components/batchSendAnnouncement";
export default {
  components: { loadingSlotDialog, Pagination, batchSendAnnouncement,importExcel,loadingDialog },
  props: {
    formType: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    formType: {
      handler() {
        this.getApplication();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      importApplicantStage:[], 
      applicationFormIds: [],
      centerDialogVisibleLoading: false,
      centerDeleteDialogVisible: false,
      total: 0,
      show3: true,
      application: [],
      multipleSelection: [],
      centerDialogVisible: false,
      formLabelAlign: {
        likeApplicant: null,
        stage: null,
        status: null,
        _page: 1,
        _limit: 10,
      },
    };
  },
  methods: {
    //格式化applicantName
    jsonParseApplicantName(row){
       return JSON.parse(row.applicantName).en + ' ' + JSON.parse(row.applicantName).zh_tc
    },
    //导入excel
    importExcel(value){
      let that = this
      this.importApplicantStage = value.map((v)=>{
        // console.log('applicationStage', v.applicationStage.trim())
        // console.log('filtersApplicationStage', that.filtersApplicationStage(v.applicationStage.trim()))
         v.newStage = that.filtersApplicationStage(v.applicationStage.trim()||'')
         return v
      })
      this.addBatchChangeApplicationFormsStage()
      // console.log('tag', this.importApplicantStage)
    },
    //Folder下拉菜单
    handleCommandFolder(v){
      if(v == 'a'){
        this.exportAttachmentsIds = this.multipleSelection.map((v)=>{
          return v.id
        })
      }
      if(v == 'b'){
        this.exportAttachmentsIds = []
      }
      this.exportAttachments()
    },
    //导出附件
    exportAttachments(){
      let from = {
        formType: this.formType,
        ids:[...this.exportAttachmentsIds],
      }
      exportAttachments(from).then(()=>{
          this.$message({
          message: "Export Success",
          type: "success",
        });
      })
    },
    //排序
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getApplication();
    },
    //分页调整
    getApplicationPagination(val){
      this.formLabelAlign._page = val.page;
      this.formLabelAlign._limit = val.limit;
      this.getApplication();

    },
    closeCenter() {
      this.centerDialogVisible = false;
    },
    //重置
    onReset() {
      Object.keys(this.formLabelAlign).forEach((v) => {
        this.formLabelAlign[v] = null;
        if(v == '_page'){
          this.formLabelAlign[v] = 1
        }
        if(v == '_limit'){
          this.formLabelAlign[v] = 10
        }
      })
      this.$refs.multipleTable.clearSelection()
      this.getApplication();
    },
    onCancel() {
      this.centerDeleteDialogVisible = false;
    },
    closeDelete() {
      this.centerDeleteDialogVisible = false;
    },
    onSearch() {
      this.getApplication();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    close(v) {
      this.centerDialogVisible = v;
    },
    //Filter下拉菜单
    handleCommand(v) {
      if (v == "b") {
        this.applicationFormIds = this.multipleSelection.map((v) => {
          return v.id;
        });
        this.centerDialogVisible = true;
      }
      if (v == "c") {
        //弹窗css
        this.$confirm('Are you sure to delete all items?')
          .then(() => {
            this.applicationFormIds = this.multipleSelection.map((v) => {
              return v.id;
            });
            this.batchDeleteApplicationForms();
          })
          .catch(() => {});
      }
      if (v == "d") {
        //弹窗css
        this.$confirm('Are you sure to delete all items?')
          .then(() => {
            this.applicationFormIds = null
            this.batchDeleteApplicationForms();
          })
          .catch(() => {});
      }
      if (v == "a") {
        this.applicationFormIds = this.multipleSelection.map((v) => {
          return v.id;
        });
        this.$router.push({
          path: `/admin/bathChangeStatus/${JSON.stringify(
            this.applicationFormIds
          )}/${this.formType}`,
        });
      }
    },
    //跳转编辑页面
    onEdit(id, type) {
      this.$router.push({ path: `/admin/application/${id}/${type}/edit` });
    },
    //跳转详情页面
    onView(id, type) {
      this.$router.push({ path: `/admin/application/${id}/${type}/detail/${this.total}` });
    },
    onConfirm() {
      this.batchDeleteApplicationForms();
    },
    //批量导出选取中的Applications
    onExport() {
      if (this.multipleSelection.length > 0) {
        this.batchExportApplicationsRequest(this.multipleSelection);
      }
    },
    //导出全部Applications
    onExportAll(){
      this.batchExportApplicationsRequest([]);
    },
    //导出pdf
    onExportPDF(id) {
      this.exportRequest(id);
    },
    //批量导出Applications
    batchExportApplicationsRequest(exports) {
      this.centerDialogVisibleLoading = true;
      let from = {
        formType: this.formType,
        applicationFormIds:exports.length>0 ? exports.map((v) => {
          return v.id;
        }) :null,
      };
      batchExportApplicationsRequest(from).then((v) => {
        if(exports.length>0){
          downloadFile(v.data, getFileName(v.data));
        }else{
          this.$message({
            message: "Export Success",
            type: "success",
          })
        }
      }).finally(()=>{
        this.centerDialogVisibleLoading = false;
      })
    },
    //导出单个申请单
    exportRequest(id) {
      exportRequest(id).then((v) => {
        downloadFile(v.data, getFileName(v.data));
      });
    },
    //批量删除表单
    batchDeleteApplicationForms() {
      let from = {
        formType: this.formType,
        applicationFormIds:this.applicationFormIds
      };
      batchDeleteApplicationForms(from)
        .then(() => {
          this.getApplication();
        })
        .finally(() => {
          this.centerDeleteDialogVisible = false;
        });
    },
    //批量修改ApplicationStage
    addBatchChangeApplicationFormsStage(){
      this.centerDialogVisibleLoading = true;
      let from = this.importApplicantStage
      addBatchChangeApplicationFormsStage(from).then(()=>{
         this.$message({
          message: "修改 Application Stage 成功",
          type: "success",
         })
         this.getApplication();
      }).finally(()=>{
        this.centerDialogVisibleLoading = false;
      })
    },
    //格式ApplicationStage
    filtersApplicationStage(value) {
        switch (value) {
          case "(S0) Not Filling form yet":
            return 0
          case "(S1) Filling form":
            return 1
          case  "(S3) Finish filling form":
            return 2
          case  "(S5) Finish upload file":
            return 3
          case  "(S6) Need correct the form information":
            return 4
          case  "(S7) Submitted the correction form":
            return 5
          case  "(S8) Form submitted (payment not settle)":
            return 6
          case "(S9) Form submitted (payment ready)":
            return 7
          case "(S10) Complete the review information":
            return 8
          case "(S11) Arranged Interview-1":
            return 9
          case "(S11A) Waiting List (1st round)":
            return 10
          case "(S12) Arranged Interview-2":
            return 11
          case "(S12A) Waiting List (2nd round)":
            return 12
          case "(S13) Provide Offered":
            return 13
          case  "(S14) No Offered":
            return 14
          case "(S15) Accepted Offer":
            return 15
          case "(S16) Rejected Offer":
            return 16
          case "(S17) No reply":
            return 17
        }
    },
    getApplication() {
      let from = {
        formType: this.formType,
        likeApplicant: this.formLabelAlign.likeApplicant,
        stage: this.formLabelAlign.stage,
        status: this.formLabelAlign.status,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getApplication(from).then((v) => {
        this.application = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
}
.page-box-title {
  display: flex;
  border-bottom: 1px solid #707070;
  justify-content: space-between;
  padding: 0 47px;
  padding-top: 46px;
  padding-bottom: 27px;
}
.search-box {
  padding-top: 50px;
  padding-bottom: 40px;
  padding-left: 50px;
  padding-right: 50px;
}
.el-button--primary {
  width: auto;
  background-color: #060c60;
  border-color: #060c60;
  font-size: 20px;
  font-weight: bold;
}
.dialog-text {
  font-size: 36px;
  color: #272727;
  text-align: center;
}
::v-deep{
  .el-button-group{
    display: flex;
  }
}
</style>